import isNil from 'lodash/isNil';
import get from 'lodash/get';
import AuthService from '@/services/AuthService';

const authService = new AuthService();

// eslint-disable-next-line consistent-return
function validateUser(userInfo) {
  const { profile } = userInfo;
  const userId = get(profile, 'x-hasura-user-id');
  const organizationID = get(profile, 'x-hasura-organization-id');
  const hasHasuraClaims = !(isNil(userId) || isNil(organizationID));
  const roles = get(profile, 'x-hasura-allowed-roles');
  const userRoles = roles.map(role => role.toUpperCase());
  const allowedRoles = ['MRO_BUYER', 'MRO_SUPPLIER', 'MRO_MANAGE_SUPPLIER'];
  const hasAccessToCAT4MRO = allowedRoles.some(r => userRoles.includes(r));
  const mainRoleIsSupplier = userRoles.includes('SUPPLIER');
  if (hasHasuraClaims) {
    if (mainRoleIsSupplier) {
      if (!hasAccessToCAT4MRO) {
        // Sólo se muestra dashboard de supplier y portales
      }
      return true;
    }
    return true;
  } else if (mainRoleIsSupplier) {
    window.location.replace(`${window.location.origin}/contact-tech-support`);
  }
  return false;
}

export default function auth({ to, next }) {
  authService.getUser().then((userInfo) => {
    if (userInfo && !userInfo.expired && validateUser(userInfo)) {
      next();
    } else {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath,
        },
      });
    }
  });
}



// WEBPACK FOOTER //
// ./src/router/middlewares/auth.js